import React from 'react'

import PreferencesButton from './PreferencesButton'

import logo from '../svg/k-board-logo.svg';

const EditorHeader = () => {
  return (
    <header className="editor-header">
      <img src={logo} alt="K-Board Editor"/>
      <PreferencesButton />
    </header>
  )
}

export default EditorHeader
